export default {
  OK: 0,
  TOO_MANY_REQUESTS: 1,
  WRONG_CODE: 2,
  EXRIRED: 3
};